import { type IFlagsmithFeature } from '@flagsmith/flagsmith';
import { type ComputedRef, computed } from 'vue';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const useFlagValue = <J extends false | true, T = undefined>(
  flag: ComputedRef<IFlagsmithFeature | undefined>,
  options?: {
    fallback?: T;
    json?: J;
  },
) => computed<(
  J extends true
  // the output will be parsed as JSON
    ? T extends undefined ? object : T

  // the output will be passed as is
    : T extends undefined
      ? (boolean | number | string)
      : T
) | null>(

  // eslint-disable-next-line complexity
  () => {
    let result = null;

    if (flag.value?.value) {
      result = flag.value.value;
    }

    if (result === null && typeof options?.fallback !== 'undefined') {
      return options.fallback;
    }

    if (result === null) {
      return null;
    }

    if (!options?.json) {
      return result as any;
    }

    try {
      return JSON.parse(result as string) as T;
    } catch {
      return options.fallback ?? null;
    }
  },
  );
